export const blogPosts3 = [
  {
    slug: "o-que-e-mysql",
    title: "O que é MySQL e onde ele é usado",
    h1: "O que é MySQL?",
    excerpt:
      "MySQL é um dos bancos de dados mais usados do mundo. Entenda o que ele é, para que serve e como funciona.",
    metaTitle: "O que é MySQL? Guia do Banco de Dados | Blog NXHOST",
    metaDescription:
      "Entenda o que é MySQL, para que serve, como funciona e por que ele é a base de sites, WordPress, lojas virtuais e sistemas.",
    focusKeyword: "o que é mysql",
    keywords: ["o que é mysql", "banco de dados mysql", "mysql e php", "banco de dados hospedagem"],
    category: "mysql",
    level: "Iniciante",
    tags: ["MySQL", "PHP", "cPanel"],
    author: "nxhost",
    publishedAt: "2026-05-04",
    updatedAt: "2026-08-20",
    readingTime: "7 min de leitura",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20database%20structure%20with%20connected%20tables%20and%20rows%20glowing%20in%20blue%20on%20a%20dark%20background%2C%20data%20storage%20concept%2C%20clean%20modern%20technology%20illustration&width=1200&height=675&seq=nx-blog-11&orientation=landscape",
    imageAlt: "Ilustração de banco de dados MySQL com tabelas conectadas",
    intro: [
      "Sempre que você cria um post no WordPress, cadastra um produto na loja virtual ou envia um formulário, essas informações normalmente vão para um banco de dados. O MySQL é um dos mais usados.",
      "Neste guia você entende o que é o MySQL, para que ele serve e como ele se encaixa no funcionamento dos sites.",
    ],
    content: [
      {
        id: "o-que-e",
        heading: "O que é MySQL?",
        level: 2,
        paragraphs: [
          "MySQL é um sistema de gerenciamento de banco de dados relacional, ou seja, ele organiza informações em tabelas com linhas e colunas, permitindo guardar e consultar dados com rapidez.",
          "É open source e está presente em grande parte dos sites do mundo, sendo a base de plataformas como o WordPress.",
        ],
      },
      {
        id: "para-que-serve",
        heading: "Para que serve o MySQL?",
        level: 2,
        list: [
          "Armazenar posts, páginas e configurações de sites.",
          "Guardar produtos, pedidos e clientes de lojas virtuais.",
          "Registrar usuários e dados de sistemas web.",
          "Salvar mensagens enviadas por formulários.",
          "Alimentar painéis e relatórios dinâmicos.",
        ],
      },
      {
        id: "como-funciona",
        heading: "Como o MySQL funciona?",
        level: 2,
        paragraphs: [
          "A aplicação do site (muitas vezes em PHP) se conecta ao banco de dados informando host, nome do banco, usuário e senha. A partir daí ela executa consultas para ler e gravar informações.",
          "Essas consultas são escritas em SQL, uma linguagem padrão para trabalhar com bancos de dados relacionais.",
        ],
      },
      {
        id: "conclusao",
        heading: "Conclusão",
        level: 2,
        paragraphs: [
          "O MySQL é a espinha dorsal de muitos sites e sistemas. Entender o básico dele ajuda a resolver problemas, fazer backups e até criar aplicações mais completas.",
        ],
      },
    ],
    faqs: [
      {
        question: "MySQL é gratuito?",
        answer:
          "Sim. O MySQL é open source e gratuito. Muitas hospedagens já disponibilizam bancos MySQL nos planos.",
      },
      {
        question: "Preciso saber MySQL para ter um site?",
        answer:
          "Não. Ferramentas como WordPress gerenciam o banco automaticamente. O conhecimento é útil para manutenção e backup.",
      },
    ],
    cta: {
      title: "Sua empresa merece uma presença digital profissional.",
      text: "Fale com a NXHOST e encontre a solução ideal para hospedar, criar e divulgar o seu projeto na internet.",
      label: "Falar com um especialista",
      to: "/solucoes",
    },
  },
  {
    slug: "como-criar-banco-de-dados-mysql",
    title: "Como criar um banco de dados MySQL",
    h1: "Como criar um banco de dados MySQL?",
    excerpt:
      "Passo a passo para criar banco de dados e usuário MySQL no painel da hospedagem e conectar com segurança.",
    metaTitle: "Como Criar um Banco de Dados MySQL | Passo a Passo | NXHOST",
    metaDescription:
      "Aprenda como criar um banco de dados MySQL, criar usuário e conectar sua aplicação com segurança, no cPanel ou DirectAdmin.",
    focusKeyword: "como criar banco de dados mysql",
    keywords: ["criar banco de dados mysql", "criar usuário mysql", "mysql cpanel", "banco de dados"],
    category: "mysql",
    level: "Iniciante",
    tags: ["MySQL", "cPanel", "DirectAdmin"],
    author: "nxhost",
    publishedAt: "2026-05-10",
    updatedAt: "2026-08-22",
    readingTime: "6 min de leitura",
    image:
      "https://readdy.ai/api/search-image?query=database%20creation%20process%20shown%20on%20a%20laptop%20screen%20with%20mysql%20tables%20and%20a%20clean%20admin%20interface%2C%20bright%20modern%20office%20desk%2C%20professional%20technology%20photography&width=1200&height=675&seq=nx-blog-12&orientation=landscape",
    imageAlt: "Criação de banco de dados MySQL em um notebook",
    intro: [
      "Antes de instalar um WordPress, uma loja virtual ou um sistema, normalmente é preciso criar um banco de dados MySQL. Parece técnico, mas é mais simples do que aparenta.",
      "Neste tutorial, veja o passo a passo usando os painéis cPanel e DirectAdmin.",
    ],
    content: [
      {
        id: "antes",
        heading: "Antes de começar",
        level: 2,
        paragraphs: [
          "Você vai precisar de três informações ao final: nome do banco, usuário e senha. Guarde tudo, pois serão usados na configuração da aplicação.",
        ],
      },
      {
        id: "passo-a-passo",
        heading: "Passo a passo no cPanel",
        level: 2,
        list: [
          "Acesse o cPanel e localize MySQL Databases.",
          "Crie um novo banco de dados e dê um nome fácil de identificar.",
          "Crie um usuário MySQL com uma senha forte.",
          "Adicione o usuário ao banco de dados.",
          "Conceda todas as permissões necessárias.",
          "Anote nome do banco, usuário, senha e host (geralmente localhost).",
        ],
      },
      {
        id: "directadmin",
        heading: "No DirectAdmin",
        level: 2,
        paragraphs: [
          "No DirectAdmin o processo é parecido: acesse MySQL Management, crie o banco, crie o usuário e associe os dois com as permissões adequadas.",
        ],
      },
      {
        id: "erros",
        heading: "Erros comuns e como evitar",
        level: 2,
        list: [
          "Usuário sem permissão no banco: revise as permissions.",
          "Nome de banco digitado errado: confira o prefixo do painel.",
          "Senha com caracteres especiais mal escapados no código.",
          "Host incorreto: em hospedagem normalmente é localhost.",
        ],
      },
      {
        id: "conclusao",
        heading: "Conclusão",
        level: 2,
        paragraphs: [
          "Criar um banco MySQL é uma tarefa rápida quando você sabe onde clicar. Com banco, usuário e permissões prontos, a aplicação consegue se conectar e funcionar corretamente.",
        ],
      },
    ],
    faqs: [
      {
        question: "Qual host devo usar na conexão MySQL?",
        answer:
          "Na maioria das hospedagens, o host é localhost. Alguns ambientes usam um endereço específico — confira na documentação ou no painel.",
      },
      {
        question: "Posso ter vários bancos de dados?",
        answer:
          "Isso depende do plano contratado. Planos de hospedagem normalmente permitem mais de um banco de dados.",
      },
    ],
    cta: {
      title: "Precisa de uma hospedagem profissional?",
      text: "Conheça as soluções de hospedagem da NXHOST e encontre uma estrutura adequada para o seu projeto.",
      label: "Conhecer hospedagem",
      to: "/hospedagem",
    },
  },
  {
    slug: "o-que-e-seo",
    title: "O que é SEO? Como aparecer no Google de forma orgânica",
    h1: "O que é SEO?",
    excerpt:
      "SEO é o conjunto de práticas que ajuda o seu site a ser encontrado pelos mecanismos de busca. Entenda os fundamentos.",
    metaTitle: "O que é SEO? Guia para Iniciantes | Blog NXHOST",
    metaDescription:
      "Entenda o que é SEO, como funciona a otimização para mecanismos de busca e os primeiros passos para aparecer no Google.",
    focusKeyword: "o que é seo",
    keywords: ["o que é seo", "seo para iniciantes", "seo on-page", "seo técnico", "aparecer no google"],
    category: "seo",
    level: "Iniciante",
    tags: ["SEO", "Google", "Site profissional"],
    author: "nxhost",
    publishedAt: "2026-05-16",
    updatedAt: "2026-08-24",
    readingTime: "8 min de leitura",
    image:
      "https://readdy.ai/api/search-image?query=search%20engine%20optimization%20concept%20with%20magnifying%20glass%20and%20upward%20growth%20chart%20on%20a%20laptop%20screen%2C%20blue%20analytics%20dashboard%2C%20clean%20modern%20office%20background&width=1200&height=675&seq=nx-blog-13&orientation=landscape",
    imageAlt: "Conceito de SEO com lupa e gráfico de crescimento",
    intro: [
      "Ter um site é só o começo. Para que ele traga clientes, é preciso que as pessoas o encontrem — e é aí que entra o SEO.",
      "Neste guia você entende o que é SEO, como os mecanismos de busca trabalham e quais são os primeiros passos para otimizar o seu site.",
    ],
    content: [
      {
        id: "o-que-e",
        heading: "O que é SEO?",
        level: 2,
        paragraphs: [
          "SEO (Search Engine Optimization) é o conjunto de práticas que ajudam o seu site a ser melhor compreendido e ranqueado pelos mecanismos de busca, como o Google.",
          "O objetivo é aparecer nas primeiras posições quando alguém pesquisa por algo relacionado ao seu negócio, gerando tráfego orgânico — sem pagar por anúncio.",
        ],
      },
      {
        id: "como-funciona",
        heading: "Como os mecanismos de busca funcionam?",
        level: 2,
        paragraphs: [
          "Os buscadores rastreiam a internet, analisam o conteúdo das páginas, indexam as informações e as classificam conforme a relevância para cada pesquisa.",
          "O SEO atua em três frentes: conteúdo, estrutura técnica e autoridade do site.",
        ],
      },
      {
        id: "pilares",
        heading: "Os pilares do SEO",
        level: 2,
        list: [
          "SEO On-Page: títulos, textos, palavras-chave, imagens e links internos.",
          "SEO Técnico: velocidade, URLs amigáveis, sitemap, robots e responsividade.",
          "Conteúdo: publicar materiais úteis que respondam às dúvidas do público.",
          "SEO Off-Page: autoridade, menções e backlinks de qualidade.",
        ],
      },
      {
        id: "primeiros-passos",
        heading: "Primeiros passos para fazer SEO",
        level: 2,
        list: [
          "Defina as palavras-chave relacionadas ao seu negócio.",
          "Estrutura correta de títulos (H1, H2, H3).",
          "Escreva meta título e descrição atrativos.",
          "Tenha URLs curtas e claras.",
          "Otimize a velocidade e a experiência mobile.",
          "Cadastre o site no Google Search Console.",
          "Crie um sitemap XML e configure o robots.txt.",
        ],
      },
      {
        id: "conclusao",
        heading: "Conclusão",
        level: 2,
        paragraphs: [
          "SEO é um trabalho contínuo, mas começa pela base: estrutura técnica correta e conteúdo útil. Nenhuma técnica promete o primeiro lugar, mas um site bem otimizado tem muito mais chances de ser encontrado.",
        ],
      },
    ],
    faqs: [
      {
        question: "Quanto tempo o SEO demora para dar resultado?",
        answer:
          "Os primeiros resultados geralmente aparecem em alguns meses e evoluem com o tempo. SEO é uma estratégia de médio e longo prazo.",
      },
      {
        question: "SEO garante o primeiro lugar no Google?",
        answer:
          "Não. Nenhuma técnica séria garante posições. O SEO aumenta as chances de aparecer bem, mas o resultado depende de concorrência e diversos fatores.",
      },
    ],
    cta: {
      title: "Quer colocar sua empresa na internet?",
      text: "A NXHOST desenvolve sites profissionais, responsivos e preparados para SEO, pensados para transformar visitantes em clientes.",
      label: "Criar meu site",
      to: "/sites",
    },
  },
  {
    slug: "como-criar-um-site",
    title: "Como criar um site profissional: guia completo",
    h1: "Como criar um site?",
    excerpt:
      "Do planejamento à publicação: entenda as etapas para criar um site profissional, responsivo e preparado para aparecer no Google.",
    metaTitle: "Como Criar um Site Profissional | Guia Completo | NXHOST",
    metaDescription:
      "Passo a passo para criar um site profissional: planejamento, estrutura, design, conteúdo, hospedagem, SEO e publicação.",
    focusKeyword: "como criar um site",
    keywords: ["como criar um site", "criar site profissional", "site para empresas", "site responsivo"],
    category: "criacao-de-sites",
    level: "Iniciante",
    tags: ["Site profissional", "WordPress", "SEO"],
    author: "nxhost",
    publishedAt: "2026-05-22",
    updatedAt: "2026-08-26",
    readingTime: "9 min de leitura",
    image:
      "https://readdy.ai/api/search-image?query=web%20designer%20creating%20a%20website%20layout%20on%20a%20large%20monitor%20with%20wireframes%20and%20code%20in%20a%20bright%20creative%20studio%2C%20blue%20accent%20tones%2C%20professional%20technology%20photography&width=1200&height=675&seq=nx-blog-14&orientation=landscape",
    imageAlt: "Designer criando a estrutura de um site em um monitor",
    intro: [
      "Criar um site profissional vai muito além de escolher um visual bonito. Envolve planejamento, estrutura, conteúdo e uma base técnica que faça o site carregar rápido e ser encontrado.",
      "Neste guia, mostramos as etapas essenciais para criar um site que represente bem o seu negócio.",
    ],
    content: [
      {
        id: "planejamento",
        heading: "1. Planejamento e objetivo",
        level: 2,
        paragraphs: [
          "Antes de qualquer coisa, defina o objetivo do site: apresentar a empresa, gerar orçamentos, vender produtos ou divulgar um serviço? Esse objetivo guia toda a estrutura.",
        ],
      },
      {
        id: "estrutura",
        heading: "2. Estrutura e conteúdo",
        level: 2,
        list: [
          "Página inicial com a proposta de valor clara.",
          "Páginas de serviços e sobre a empresa.",
          "Canal de contato e formulário.",
          "Conteúdo que responda às dúvidas dos clientes.",
        ],
      },
      {
        id: "design",
        heading: "3. Design e experiência",
        level: 2,
        paragraphs: [
          "O design precisa transmitir credibilidade e facilitar a navegação. Cores, tipografia, espaçamento e imagens devem estar alinhados à identidade da marca — e tudo precisa funcionar bem no celular.",
        ],
      },
      {
        id: "tecnico",
        heading: "4. Base técnica",
        level: 2,
        list: [
          "Hospedagem confiável e domínio próprio.",
          "Certificado SSL (HTTPS).",
          "Estrutura otimizada para velocidade.",
          "Responsividade para todos os dispositivos.",
          "Boas práticas de SEO desde o início.",
        ],
      },
      {
        id: "publicacao",
        heading: "5. Publicação e evolução",
        level: 2,
        paragraphs: [
          "Depois de publicado, o site precisa ser acompanhado: atualizar conteúdo, monitorar o Google Search Console, avaliar acessos e melhorar continuamente.",
        ],
      },
      {
        id: "conclusao",
        heading: "Conclusão",
        level: 2,
        paragraphs: [
          "Criar um site profissional combina design, tecnologia e estratégia. Cuidando dessas etapas, o seu site trabalha a favor do negócio: apresenta, convence e gera oportunidades.",
        ],
      },
    ],
    faqs: [
      {
        question: "Posso criar meu site sozinho?",
        answer:
          "É possível com plataformas prontas, mas um projeto profissional considera design, performance, SEO e conversão — pontos que fazem diferença no resultado.",
      },
      {
        question: "Preciso pagar hospedagem e domínio?",
        answer:
          "Sim. Todo site na internet precisa de um domínio (o endereço) e de uma hospedagem (onde os arquivos ficam armazenados).",
      },
    ],
    cta: {
      title: "Quer colocar sua empresa na internet?",
      text: "A NXHOST desenvolve sites profissionais, responsivos e preparados para SEO, pensados para transformar visitantes em clientes.",
      label: "Criar meu site",
      to: "/sites",
    },
  },
];